export enum TIME {
	DAY_IN_MS = 24 * 60 * 60 * 1000,
}
